module.exports = __webpack_public_path__ + "img/Property Manager icon.bb95b6d.png";